module.exports = __webpack_public_path__ + "img/left_grey_arrow.2ceed5f3.svg";